import { Button, FlexLayout, Icon } from '@deity-io/portal-ui';
import {
  ConfirmationModal,
  DeployPackageVersionModal,
  EditPublishedPackageVersionModal,
  PublishPackageVersionModal
} from 'components';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  GetAllPackageVersionsDocument,
  GetPackageVersionDocument,
  useGetPackageVersionQuery,
  useUndeployPackageVersionMutation
} from 'services/graphql/generated/hooks';
import { ContentStatus } from 'services/graphql/generated/schemas';
import { getParams } from 'utils';

export const PackageActionButtons: FC = () => {
  const { pathname } = useLocation();
  const params = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const [isUndeployModalOpen, seIsUndeployModalOpen] = useState(false);
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [isEditDeployModalOpen, setIsEditDeployModalOpen] = useState(false);
  const [isEditPublishModalOpen, setIsEditPublishModalOpen] = useState(false);
  const [isDeployModalOpen, setIsDeployModalOpen] = useState(false);
  const { data, loading } = useGetPackageVersionQuery({
    variables: {
      uuid: params?.versionUuid
    },
    skip: !params?.versionUuid,
    ...CACHE_FIRST
  });
  const [undeployPackageVersion] = useUndeployPackageVersionMutation({
    refetchQueries: [
      {
        query: GetPackageVersionDocument,
        variables: {
          versionUuid: params?.versionUuid
        }
      },
      {
        query: GetAllPackageVersionsDocument,
        variables: {
          packageUuid: params.packageId,
          limit: 20,
          offset: 0
        }
      }
    ]
  });
  const isDeployed = data?.getPackageVersion?.status === ContentStatus.Deployed;
  const isPublished = data?.getPackageVersion?.status === ContentStatus.Published;
  const isPublishedOrDeployed = isPublished || isDeployed;

  return !loading && data ? (
    <>
      <FlexLayout>
        {/* {isDeployed && (
          <>
            <Button startIcon={<Icon icon="edit" />} onClick={() => setIsEditDeployModalOpen(true)}>
              Edit package
            </Button>
            <Button sx={{ ml: 3 }} startIcon={<Icon icon="cloudUpload" />} onClick={() => seIsUndeployModalOpen(true)}>
              undeploy
            </Button>
          </>
        )} */}
        {isPublishedOrDeployed && (
          <Button variant="text" startIcon={<Icon icon="edit" />} onClick={() => setIsEditPublishModalOpen(true)}>
            Edit package
          </Button>
        )}
        {isDeployed && (
          <Button sx={{ ml: 3 }} startIcon={<Icon icon="cloudUpload" />} onClick={() => seIsUndeployModalOpen(true)}>
            undeploy
          </Button>
        )}
        {isPublished && !isDeployed && (
          <Button sx={{ ml: 3 }} startIcon={<Icon icon="cloudUpload" />} onClick={() => setIsDeployModalOpen(true)}>
            Deploy
          </Button>
        )}
        {!isPublishedOrDeployed && (
          <>
            {/* TODO: Implement after deciding how we deal with changes and updates to the CRUD API */}
            {/* <Button variant="text" startIcon={<Icon icon="done" />}> */}
            {/*  Save draft */}
            {/* </Button> */}
            <Button sx={{ ml: 3 }} startIcon={<Icon icon="doneAll" />} onClick={() => setIsPublishModalOpen(true)}>
              Save & Publish
            </Button>
          </>
        )}
      </FlexLayout>

      <PublishPackageVersionModal isOpen={isPublishModalOpen} setIsOpen={setIsPublishModalOpen} />
      {/* <EditDeployedPackageVersionModal isOpen={isEditDeployModalOpen} setIsOpen={setIsEditDeployModalOpen} /> */}
      <EditPublishedPackageVersionModal isOpen={isEditPublishModalOpen} setIsOpen={setIsEditPublishModalOpen} />
      <DeployPackageVersionModal isOpen={isDeployModalOpen} setIsOpen={setIsDeployModalOpen} />
      <ConfirmationModal
        isOpen={isUndeployModalOpen}
        setIsOpen={seIsUndeployModalOpen}
        entityType="package version"
        entityUuid={params?.versionUuid}
        actionType="undeploy"
        confirmText="Undeploy"
        onConfirm={versionUuid => versionUuid && undeployPackageVersion({ variables: { uuid: versionUuid } })}
      />
    </>
  ) : null;
};
